export type Destination = string | ((shopId: number) => string);

export const resolveDestination = (destination: Destination, shopId?: number) => {
  if (typeof destination === "string") return destination;
  if (shopId === undefined) return undefined;
  return destination(shopId);
};

const to = {
  root: "/",
  login: "/login",
  register: "/register",
  passwordReset: "/password-reset",
  setPassword: (key: string) => `/set-password/${key}`,
  createAccount: (key: string) => `/create-account/${key}`,
  accountCreationSuccess: "/create-account/success",
  accountCreationOnboarding: "/create-account/onboarding",

  dashboard: (shopId: number) => `/shop/${shopId}/dashboard`,
  dashboardOld: "/dashboard-old",
  browseAbandonment: (shopId: number) => `/shop/${shopId}/features/browse-abandonment`,
  comeBackMailing: (shopId: number) => `/shop/${shopId}/features/come-back-mailing`,
  triggerMailsPayment: (shopId: number) =>
    `/shop/${shopId}/products/trigger-mails-payment-settings`,
  triggerMailsBlock: "/admin/trigger-mails-block",
  questionnaire: (shopId: number) => `/shop/${shopId}/account/onboarding-questionnaire`,
  contactPersons: (shopId: number) => `/shop/${shopId}/contact-persons`,
  shopLinks: (shopId: number) => `/shop/${shopId}/shop-links`,
  maintenance: "/maintenance",

  activationPopups: (shopId: number) => `/shop/${shopId}/features/activation-popups`,
  abandonmentMails: (shopId: number) => `/shop/${shopId}/features/abandonment-mails`,
  newsletterForms: (shopId: number) => `/shop/${shopId}/features/newsletter-forms`,
  integrations: (shopId: number) => `/shop/${shopId}/integrations`,
  algorithm: (shopId: number) => `/shop/${shopId}/algorithm`,
  account: (shopId: number) => `/shop/${shopId}/account/my-account`,
  tracking: (shopId: number) => `/shop/${shopId}/products/tracking`,
  shopConfiguration: (shopId: number) => `/shop/${shopId}/products/shop-configuration`,

  activationDesigner: (shopId: number) => `/shop/${shopId}/activationDesigner`,
  activationManager: "/admin/activationManager",
  cmsEditor: "/admin/editor/content",
  templateEditor: "/admin/template-editor",
  abTests: (shopId: number) => `/shop/${shopId}/abtests`,
  mailTemplates: "/admin/mailTemplates",
  fuzzyEditor: (shopId: number) => `/shop/${shopId}/fuzzyEditor`,

  reportedRegains: "/admin/reported-regains",
  reportedSubscriptions: "/admin/reported-subscriptions",
  storeAdministration: "/admin/store-administration",
  userAdministration: "/admin/user-administration",
  featureToggles: "/admin/feature-toggles",
  testPricingForm: "/admin/test-pricing-form",
  provisionDashboard: "/admin/sales/provision",

  mailCancellationDrops: "/admin/analysis/mainCancellationDrops",
  activationCancellationDrops: "/admin/analysis/activationCancellationDrops",
  activationRegainDrops: "/admin/analysis/activationRegainDrops",
  mailRegainDrops: "/admin/analysis/mailRegainDrops",
  sessionDrops: "/admin/analysis/sessionDrops",
  orderDrops: "/admin/analysis/orderDrops",
  zeroScv: "/admin/analysis/zeroScv",
  invoiceDrops: "/admin/analysis/invoiceDrops",
  invoices: "/admin/analysis/invoices"
} as const;

export { to };
